/**
 * Insect Lore Cookie Handler
 */
const insectLoreCookies = {
    /**
     * Create a cookie
     * @param {string} name - The name of the cookie.
     * @param {*} value - The value to store in the cookie.
     * @param {Date|number|string} [expires] - Expiration date or time (in days).
     * @param {string} [path] - The path where the cookie is accessible.
     * @param {string} [domain] - The domain where the cookie is accessible.
     */
    createCookie(name, value, expires, path, domain) {
        let cookie = `${encodeURIComponent(name)}=${encodeURIComponent(value)};`;

        if (expires) {
            let expiryDate;
            if (expires instanceof Date) {
                expiryDate = isNaN(expires.getTime()) ? new Date() : expires;
            } else {
                expiryDate = new Date(Date.now() + parseInt(expires, 10) * 24 * 60 * 60 * 365);
            }
            cookie += `expires=${expiryDate.toUTCString()};`;
        }

        if (path) {
            cookie += `path=${path};`;
        }

        if (domain) {
            cookie += `domain=${domain};`;
        }

        document.cookie = cookie;
    },

    /**
     * Retrieve a cookie by name.
     * @param {string} cname - The name of the cookie.
     * @returns {string|null} The value of the cookie, or null if not found.
     */
    getCookie(cname) {
        const nameEQ = `${encodeURIComponent(cname)}=`;
        const cookies = document.cookie.split(';');

        for (let cookie of cookies) {
            cookie = cookie.trim();
            if (cookie.startsWith(nameEQ)) {
                return decodeURIComponent(cookie.substring(nameEQ.length));
            }
        }
        return null;
    },

    /**
     * Delete a cookie by name, path, or domain.
     * @param {string} name - The name of the cookie.
     * @param {string} [path] - The path of the cookie to delete.
     * @param {string} [domain] - The domain of the cookie to delete.
     */
    deleteCookie(name, path, domain) {
        this.createCookie(name, "", -1, path, domain);
    }
};

$(document).ready(function() {
    initDescriptionToggle();
    removeExpiredDeliverDateValue();
    updateCartSubtotalWithVouchers();
    validateDeliveryDate();
});

/**
 * Initializes the description toggle functionality.
 * If the description element exists and has the data-option-readmore attribute set to true,
 * it enables the readmore functionality with a specified speed and less link.
 */
const initDescriptionToggle = () => {
    const description = $('#description');
    if (description.length > 0 && description.attr('data-option-readmore') === 'true') {
        description.readmore({speed: 75, lessLink: '<a href="javascript:void(0)">Read less</a>'});
    }
}

/**
 * Updates cart by removing expired delivery date
 * @returns {Promise<void>}
 */
const removeExpiredDeliverDateValue = async () => {
    const currentDate = Date.parse(new Date().toDateString());
    const sessionDeliveryDate = sessionStorage.getItem('deliveryDate');
    const cartDeliveryDate = await getDeliveryDateFromCart();    

    const isDateExpired = (date) => {
        if (!date) return false;
        return Date.parse(date) < currentDate;
    };

    const clearDeliveryDate = async () => {
        const requestBody = JSON.stringify({
            attributes: {
                deliveryDate: null
            }
        });

        try {
            await fetch('/cart/update.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-Requested-With': 'XMLHttpRequest'
                },
                credentials: 'same-origin',
                body: requestBody
            });

            sessionStorage.removeItem('deliveryDate');
            insectLoreCookies.deleteCookie('future_date');
            location.reload();
        } catch (error) {
            console.error('Failed to update cart:', error);
        }
    };
    
    if (isDateExpired(cartDeliveryDate)) {
        await clearDeliveryDate();
        return;
    }

    if (isDateExpired(sessionDeliveryDate)) {
        await clearDeliveryDate();
        return;
    }
};

/**
 * Retrieves the delivery date from the cart.
 * @returns {string|null} The delivery date, or null if not found.
 */
const getDeliveryDateFromCart = async () => {
    const cart = await $.getJSON('/cart.js');
    if (cart.attributes.deliveryDate) {
        return cart.attributes.deliveryDate;
    }

    return null;
}

/**
 * Handles the application of a discount code and updates the cart subtotal.
 * Retrieves the voucher code, variant ID, and main product ID from local storage.
 * If a voucher code is present, it applies the discount and updates the cart subtotal.
 * If no voucher code is present, it removes the discount code input and updates the cart subtotal with a default shipping fee.
 */
const updateCartSubtotalWithVouchers = () => {
    $.getJSON('/cart.js', function(cart) {
        const subtotalContainer = $('.subtotal .js-cart_subtotal');
        const subtotalBlock = subtotalContainer.find('.money');
        const cartSavingsBlock = $('.cart_savings.js-cart_savings');
        let cartTotal = cart.total_price / 100;
        let redemptionFee = 0;
        let subtotal = 0;

        cart.items.forEach(function(item) {
            const itemRedemptionFee = Number(item.properties?.Redemption_Fee) || 0;
            let itemPrice = item.original_price;

            if (itemRedemptionFee > 0) {
                const cartItemBlock = $('.cart__wrapper .cart__item[data-itemid="' + item.id + '"]');
                cartItemBlock.find('.price_total .was_price').text('$' + (itemPrice / 100).toFixed(2));
            } else {
                let discountedPriceBlock = $('.cart__wrapper .cart__item[data-itemid="' + item.id + '"]').find('.modal_price .was_price');
                let hasDiscountedPrice = discountedPriceBlock.length > 0;
                if (hasDiscountedPrice) {
                    itemPrice = discountedPriceBlock.data('price');
                }
            }

            subtotal += itemPrice * item.quantity;
            redemptionFee += itemRedemptionFee;
        });

        cartTotal += redemptionFee;

        subtotalBlock.text('$' + (subtotal / 100).toFixed(2));
        if (redemptionFee > 0) {
            subtotalContainer.append("<p class='redemption_fee'><span>Redemption Fee :</span><span class='right'><span class='money'>$" + redemptionFee.toFixed(2) + "</span></span></p>");
            cartSavingsBlock.find('>span:last-child').text('Vouchers');
        }

        subtotalContainer.append("<p class='grand_total'><span>Subtotal:</span><span class='right'><span class='money'>$" + cartTotal.toFixed(2) + "</span></span></p>");
        $('.cart_savings').insertBefore('.grand_total');
        $('.shopify-section--cart-template .subtotal #checkout').removeAttr('disabled');
    });
}

/**
 * Validates the delivery date selected by the user.
 * If the selected date is in the past, it prevents the form submission and displays an error message.
 * If the selected date is valid, it stores the date in session storage.
 */
const validateDeliveryDate = () => {
    $('.cart__wrapper .subtotal button.add_to_cart').on('click', (event) => {
        const dateValue = $('#datepicker').val();
        if (dateValue) {
            const now = new Date();
            const currentDate = Date.parse(now.toDateString());
            const deliveryDate = Date.parse(dateValue);

            if (deliveryDate < currentDate) {
                event.preventDefault();
                const html = '<p style="color:red;">Please Select a Future Date.</p>';
                if ($('.future-date').siblings('p').length < 1) {
                    $(html).insertAfter('.future-date');
                }
                $('.future-date input').css('border', '1px solid red');
            } else {
                sessionStorage.setItem("deliveryDate", dateValue);
                return true;
            }
        } else {
            sessionStorage.setItem("deliveryDate", "");
        }
    });
}
